cb.define([], function (common) {
  var AA_aa_paymentmethod_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var self = this;
		var storeModel = viewmodel.get('paymentMethodStore');
		if (storeModel) {
			//过滤掉列表存在的数据
			storeModel.on('beforeBrowse', function (data) {

			if(data != undefined)
			{
				var rows = storeModel.getRows();
				var id = [];
				rows.forEach(function (item, index) {
					if (data.rowIndex === index) return;
					if (item.store_name === undefined) return;
					id.push(item.store);
				})
				switch (data.cellName) {
					case "store_name":
					var condition = { "isExtend": true, simpleVOs: [] };
					condition.simpleVOs.push({
					field: 'id',
					op: 'nin',
					value1: id
				  });
				  data.context.setFilter(condition);
				  break;
				}
			}
			});
			//已经选择的门店不能再次选择
			storeModel.on('beforeCellValueChange', function (data) {
			  if (data.cellName === 'store_name') {

				var rows = storeModel.getRows();
				var storeid = [];
				rows.forEach(function (item, index) {
				  if (data.rowIndex === index) return;
				  storeid.push(item.store);
				})
				if(data.value != undefined)
				{
					if (storeid.indexOf(data.value.id) > -1)
						return false;
				}
			  }
			});
		}
		viewmodel.on('beforeSave', function(args) {
			var beforeSavePromise = new cb.promise();
			var proxy = cb.rest.DynamicProxy.create({
            settle: { url: 'payment/isdefault', method: 'GET' }
			});
			var params = {
				billnum : "aa.paymentmethod",
				data: viewmodel.get('isDefault').getValue(),
				id : viewmodel.get('id').getValue(),
			};
			proxy.settle(params, function (err, result) {
			  if (err) {
				cb.utils.alert(err.message, 'error');
				return;
			  }
			  if (result != undefined) {
				 if(result)
				 {
					 cb.utils.confirm("已存在默认收款类型是否修改？", function() {
            beforeSavePromise.resolve();
           }, function() {
            beforeSavePromise.reject();
           });
				 }else{
					 beforeSavePromise.resolve();
				 }

			  }

			  //viewmodel.execute('refresh');
			  //cb.utils.alert('客户结算执行成功', 'success');
			});
			return beforeSavePromise;
		});
		viewmodel.get("paymentType").on("beforeValueChange", function (data) {
			if (!data.value) return;
			if(data.value.value != 1)
			{
				viewmodel.get("isDefault").setValue(false);
			}else{
				viewmodel.get("isDefault").setValue(true);
			}
			if(data.value.value == 1 || data.value.value == 3 || data.value.value == 4)
			{
				viewmodel.get("isQuick").setValue(true);
			}else{
				viewmodel.get("isQuick").setValue(false);
			}

			return true;
        });
    },
  }
  try {
    module.exports = AA_aa_paymentmethod_VM_Extend;
  } catch (error) {

  }
  return AA_aa_paymentmethod_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_paymentmethod_VM.Extend.js